<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="accent white--text title">
                    {{itemDefinition.title}}
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12>
                            <date-range-selector v-model="range"></date-range-selector>
                            <equipment-selector v-if="itemDefinition.hasEquipmentSelector" v-model="equip" :typeFilter="itemDefinition.equipmentTypeFilter"></equipment-selector>
                            <v-switch
                                    v-model="onOnly"
                                    v-if="itemDefinition.hasOnOnlySwitch"
                                    label="View Points when Chiller is On"
                            ></v-switch>

                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex v-for="plot in itemDefinition.plotList" :key="itemDefinition.title+plot.id"  v-bind:class="[plot['flex-class'], 'xs12']" >
                                <scatter-plot v-if="plot.type==='scatter'" ref="plots"
                                              :variable-x="plot.config['variable-x']"
                                              :variable-y="plot.config['variable-y']"
                                              :facility_name="facility_name"
                                              :equipment_name="equip"
                                              :on-only="plot.config['on-only']"
                                              :date-range="range"
                                              :type="plot.config['type']"
                                ></scatter-plot>
                                <cop-plot v-if="plot.type==='cop'" ref="plots"
                                              :variable-x="plot.config['variable-x']"
                                              :variable-y="plot.config['variable-y']"
                                              :facility_name="plot.config['facility_name'] ? plot.config['facility_name'] : facility_name"
                                              :date-range="range"
                                          just-plot
                                              :layout-overrides="plot.config['layout-overrides']"
                                              :extra-vars="plot.config['extra-vars']"
                                              :type="plot.config['type']"
                                              :api-base-url="plot.config['apiBaseUrl']"
                                              :ony2="plot.config['ony2']"
                                              :mode="plot.config['mode']"
                                ></cop-plot>
                                <refrigerant-temp-pressure-plot ref="plots"
                                                                v-if="plot.type==='refrigerant-temp-pressure'"
                                                                :date-range="range"
                                                                :typeFilter="itemDefinition.equipmentTypeFilter"
                                                                :variable-x="plot.config['variable-x']"
                                                                :variable-y="plot.config['variable-y']"
                                                                :on-only="onOnly"
                                                                :type="plot.config['type']"
                                ></refrigerant-temp-pressure-plot>
                                <facet-plot ref="plots" v-if="plot.type==='facet'"
                                            :variable-x="plot.config['variable-x']"
                                            :variable-y="plot.config['variable-y']"
                                            :facility_name="facility_name"
                                            :equipment_name="equip"
                                        :date-range="range"
                                        :on-only="onOnly"
                                        :facet-groups="plot.config['facet-groups']"
                                        :variable-facet="plot.config['variable-facet']"
                                >
                                </facet-plot>
                                <multi-plot-chart ref="plots" v-if="plot.type==='multi-chart'"
                                                  just-plot
                                                  :equipment-name="equip"
                                        :on-only="onOnly"
                                                  disable-responsive
                                        :date-range="range"
                                                  :variable-x="plot.config['variable-x']"
                                        :variables-list="plot.config['variables-list']"
                                        :layout-overrides="plot.config['layout-overrides']"
                                                  :type="plot.config['type']"
                                ></multi-plot-chart>
                            <data2-chart ref="plots" v-if="plot.type==='data2-chart'"
                                         :layout-overrides="plot.config['layout-overrides']"
                                         :x-axis="plot.config['x-axis']"
                                         :on-only="onOnly"
                                         disable-responsive
                                         :data-payload="plot.config['data-payload']"
                                         :series-overrides="plot.config['series-overrides']"
                                         just-plot :date-range="range"></data2-chart>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                           @click="exportAll()"
                    >
                        Export all as PDF
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import DateRangeSelector from '../../components/DateRangeSelector'
    import EquipmentSelector from '../../components/EquipmentSelector'
    import ScatterPlot from '../../components/ScatterPlot'
    import RefrigerantTempPressurePlot from '../../components/faults/RefrigerantTempPressurePlot'
    import exportAllToPDF from '../../components/mixins/exportAllToPDF'
    import MultiPlotChart from "../../components/MultiPlotChart"
    import FacetPlot from "../../components/FacetPlot";
    import CopPlot from "../../components/CopPlot";
    import Data2Chart from "../../components/Data2Chart";
    import moment from 'moment'


    export default {
        name: 'PlotList',
        components: {ScatterPlot, EquipmentSelector, DateRangeSelector,RefrigerantTempPressurePlot,MultiPlotChart,FacetPlot,CopPlot,Data2Chart},
        props: ['itemDefinition'],
        mixins:[exportAllToPDF],
        data() {
            return {
                equip: null,
                range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
                onOnly: false
            }
        },
        computed: {
            facility_name() {
                return this.$store.state.pointsListStore.facility_name
            },
        },
        methods:{
            async exportAll(){
                this.exportAllItems(this.$refs.plots);
            }
        },
        beforeMount() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.range={start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
            }
        }
    }
</script>
